















































import { Component, Vue, Watch } from 'vue-property-decorator';
import { Action, Getter, Mutation } from 'vuex-class';
import { Pagination, sortOrdering } from '../models/pagination';
import { ListParams } from '../models/list-params';
import { InvoiceListItem } from '../models/invoice-list-item';
import { errorMessage } from '../store/types';

@Component({
  name: 'Invoices',
})
export default class Invoices extends Vue {
  @Action('org/invoices/fetchInvoices') fetchInvoices!: (
    queryParams: ListParams
  ) => Promise<number>;
  @Getter('org/invoices/getInvoices') invoices!: () => InvoiceListItem[];
  @Getter('org/invoices/getSearch') getSearch!: string;
  @Mutation('org/invoices/setSearch') setSearch!: (search: string) => void;

  loading = true;
  pagination: Pagination = {
    page: 1,
    itemsPerPage: 20,
    sortBy: ['invoiceNumber'],
    sortDesc: [true],
  };
  totalInvoices = 1;
  errorMessage = '';

  tableHeaders = [
    { text: 'Vendor', value: 'vendor', sortable: false },
    { text: 'Invoice #', value: 'invoiceNumber', align: 'right' },
    { text: 'Date', value: 'date', align: 'right' },
    { text: 'Ship to', value: 'shipTo', sortable: false },
    { text: 'Reference', value: 'reference' },
    { text: 'Total', value: 'total', align: 'right' },
  ];

  @Watch('pagination')
  onPropertyChanged(pagination: Pagination) {
    this.pagination.page = pagination.page;
    this.getData({
      page: this.pagination.page,
      limit: this.pagination.itemsPerPage,
      sort: sortOrdering(this.pagination),
      q: this.getSearch,
    });
  }

  searchHandler(search: string): void {
    this.setSearch(search);
    this.getData({
      page: this.pagination.page,
      limit: this.pagination.itemsPerPage,
      sort: sortOrdering(this.pagination),
      q: this.getSearch,
    });
  }

  getData(queryParams: ListParams): void {
    this.loading = true;

    this.fetchInvoices(queryParams)
      .then(totalItemsFound => {
        this.loading = false;
        this.totalInvoices = totalItemsFound;
      })
      .catch((error: errorMessage) => {
        this.loading = false;
        this.errorMessage = error.message;
      });
  }

  openInvoice(invoice: InvoiceListItem) {
    this['$router'].push(`invoices/${invoice.invoiceNumber}`);
  }
}
